import React, { Component } from "react";
import TenantMatchList from "../../Shared/Matches/TenantMatchList";
import PropTypes from "prop-types";
import MatchController from "../../Shared/Matches/MatchController";
import { Switch, Route, Redirect } from "react-router";
import ProfileMatchInfo from "../ProfileMatchInfo";

export default class TenantMatches extends Component {

    static propTypes = {
        matches: PropTypes.array.isRequired,
        setFavorite: PropTypes.func.isRequired
    }

    render() {
        const { ...props } = this.props;
        return (
            <Switch>
                <Route exact path="/user/matches" render={ ps => {
                    return (
                        <div className="User-content">
                            <MatchController
                                landlord
                                listComponent={TenantMatchList}
                                {...props}
                            />
                        </div>
                    );
                } } />
                <Route path="/user/matches/:annoId/:propId" render={ ps => {
                    const annoId = Number( ps.match.params.annoId );
                    const propId = ps.match.params.propId;
                    if ( propId == undefined )
                        return <Redirect to="/user/matches"/>;
                    return (
                        <ProfileMatchInfo
                            propId={propId}
                            annoId={annoId}
                        />
                    );
                } } />
            </Switch>
        );
    }

}